import Alpine from "alpinejs";

/**
 * Make links only clickable when shift is pressed
 */
Alpine.data("shiftLink", () => ({
    init() {
        Alpine.bind(this.$root, this.root);
    },
    clickable: false,
    click(event) {
        if (!this.clickable) {
            event.preventDefault();
        }
    },
    root: {
        ["x-on:click.capture"](event) {
            this.click(event);
        },
        ["x-on:keydown.enter"](event) {
            this.click(event);
        },
        ["x-on:keydown.shift"]() {
            this.clickable = true;
        },
        ["x-on:keyup"]() {
            this.clickable = false;
        },
    },
}));
